<template>
  <div class="h-full w-full bg-white shadow-lg rounded-lg p-2">
    <div
      v-if="isLoading"
      class="grid grid-cols-1 sm:grid-cols-2 lg:flex gap-4 px-1 pt-4"
    >
      <SkeletonCard v-for="index in 4" :key="index" />
    </div>

    <div
      v-else
      class="mb-6 xxl:mb-4 grid grid-cols-1 sm:grid-cols-2 lg:flex gap-4 px-1 pt-4"
    >
      <PodiumCard
        v-if="kpiTop3Data && kpiData"
        title="Faturamento Top #3"
        :top3Value="kpiTop3Data.periodBilling"
        :totalValue="kpiData.periodBilling"
        formatType="currency"
      />
      <PodiumCard
        v-if="kpiTop3Data && kpiData"
        title="Quant. Vendas Top #3"
        :top3Value="kpiTop3Data.periodSales"
        :totalValue="kpiData.periodSales"
        formatType="number"
      />
      <PodiumCard
        v-if="kpiTop3Data && kpiData"
        title="Ticket Médio Top #3"
        :top3Value="kpiTop3Data.ticketAverage"
        :totalValue="kpiData.ticketAverage"
        formatType="currency"
      />
      <GeneralCard
        v-if="kpiData"
        title="Projeção Anual Vendas"
        :value="`${formatCurrencyStandard(kpiData.projectedAnnualBilling)}`"
      />
    </div>

    <div
      class="flex flex-col md:flex-row w-full items-end justify-center mt-12"
    >
      <SkeletonPlacementPodium v-if="isLoading" />

      <PlacementPodium
        v-if="!isLoading"
        :bestConsultants="top3Ranked"
        :rankingCriteria="dataSend.rankingCriteria"
      />

      <div class="flex flex-col items-center w-full max-w-lg">
        <SkeletonPodiumPlacementTable v-if="isLoading" />
        <PodiumPlacementTable
          v-if="!isLoading"
          :data="otherConsultants"
          :is-presentation-mode="isPresentationMode"
        />

        <SkeletonRewardImage v-if="isLoading" />
        <RewardImage
          v-if="!isLoading"
          :rankingCriteria="dataSend.rankingCriteria"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PodiumCard from '../components/PodiumCard.vue';
import GeneralCard from '../../../../components/GeneralCard.vue';
import SkeletonCard from '../../../../components/SkeletonCard.vue';
import PlacementPodium from '../components/PlacementPodium.vue';
import SkeletonPlacementPodium from '../components/SkeletonPlacementPodium.vue';
import SkeletonPodiumPlacementTable from '../components/SkeletonPodiumPlacementTable.vue';
import SkeletonRewardImage from '../components/SkeletonRewardImage.vue';
import PodiumPlacementTable from '../components/PodiumPlacementTable.vue';
import { PodiumMixin } from '../mixins';
import RewardImage from '../components/RewardImage.vue';

export default {
  name: 'ConsultantPodium',
  props: {
    isPresentationMode: Boolean,
    initialDate: String,
    finalDate: String,
    dataSend: Object,
  },
  components: {
    PodiumCard,
    PlacementPodium,
    PodiumPlacementTable,
    GeneralCard,
    RewardImage,
    SkeletonCard,
    SkeletonPlacementPodium,
    SkeletonPodiumPlacementTable,
    SkeletonRewardImage,
  },
  mixins: [PodiumMixin],
  async mounted() {
    this.isLoading = true;
    await this.createTemporaryTables();
    await this.fetchKpi();
    await this.fetchData('annual-podium', 'getBestConsultantsPodium');
    await this.dropTemporaryTables();
    this.isLoading = false;
  },
};
</script>

<style scoped>
.custom-min-height {
  min-height: 124px;
}
</style>
